import { Skeleton, TableCell, TableRow } from '@hub-la/shadcn'

export const TableLoading = () => {
  return (
    <TableRow>
      <TableCell className="py-4">
        <Skeleton className="w-[70%] h-6" />
      </TableCell>

      <TableCell className="py-4">
        <Skeleton className="w-[50%] h-6" />
      </TableCell>

      <TableCell className="py-4">
        <Skeleton className="w-[30%] h-6" />
      </TableCell>

      <TableCell className="py-4">
        <Skeleton className="w-full h-6" />
      </TableCell>
    </TableRow>
  )
}
